import type { IconData } from '@stacksjs/iconify-core'

export const divisionCircleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5S1.5 36.426 1.5 24M24 9.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7m0 29a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7m11.437-11.181c-1.882.084-5.369.181-11.437.181s-9.555-.097-11.437-.181c-1.352-.06-2.835-.746-3.013-2.356q-.049-.427-.05-.963c-.001-.536.018-.678.05-.963c.178-1.61 1.661-2.295 3.013-2.356c1.882-.084 5.369-.181 11.437-.181s9.555.097 11.437.181c1.352.06 2.835.746 3.013 2.356q.049.427.05.963c.001.536-.018.678-.05.963c-.178 1.61-1.661 2.296-3.013 2.356\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default divisionCircleSolid
